import { render, staticRenderFns } from "./index_v2.vue?vue&type=template&id=76dcb142&scoped=true&"
import script from "./index_v2.vue?vue&type=script&lang=js&"
export * from "./index_v2.vue?vue&type=script&lang=js&"
import style0 from "./index_v2.vue?vue&type=style&index=0&id=76dcb142&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76dcb142",
  null
  
)

export default component.exports